module.exports = __webpack_public_path__ + "static/media/closetab.41522cab.svg";